import React from 'react';

export default ({ color = '#1F8A5B', size = 15 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.64277 4.37484L5.22748 5.95956L4.34359 6.84344L1.25 3.74984L4.34359 0.65625L5.22748 1.54014L3.64277 3.12484H8.125C10.8864 3.12484 13.125 5.36342 13.125 8.12488C13.125 10.8863 10.8864 13.1249 8.125 13.1249H2.5V11.8749H8.125C10.1961 11.8749 11.875 10.1959 11.875 8.12488C11.875 6.05378 10.1961 4.37484 8.125 4.37484H3.64277Z"
      fill={color}
    />
  </svg>
);
